import { pxToRem as basePxToRem } from '../../../lib';
var themeFontSizeInPx = 14;
export var pxToRem = function (sizeInPx) { return basePxToRem(sizeInPx, themeFontSizeInPx); };
